import React from 'react';
import { cnBem } from '@carnica/utils';
import { Button, Text } from '@carnica/ui-kit';
import { pushPersonalAccountAnalytics } from "../../../../../../utils";
import styles from "./styles.pcss";
import { CardIcon } from "./components/CardIcon";
var cnCardItem = cnBem('card-item', styles);
export var CardItem = function CardItem(_ref) {
  var item = _ref.item,
    userType = _ref.userType;
  var handleSendAnalytics = function handleSendAnalytics() {
    if (window) {
      var _window, _window$location;
      pushPersonalAccountAnalytics({
        element_text: item === null || item === void 0 ? void 0 : item.name,
        account_type: userType
      });
      window.location.href = "".concat((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin, "/").concat(item === null || item === void 0 ? void 0 : item.link);
    }
  };
  return /*#__PURE__*/React.createElement("li", {
    className: cnCardItem(null, ['main']),
    "data-t-id": "components-CardItem"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSendAnalytics
  }, /*#__PURE__*/React.createElement(CardIcon, {
    cardType: item === null || item === void 0 ? void 0 : item.key,
    "data-t-id": "components-CardItem"
  }), /*#__PURE__*/React.createElement(Text, {
    className: cnCardItem(null, ['title']),
    size: "xs"
  }, item === null || item === void 0 ? void 0 : item.name)));
};